import ContentOverlay from "../components/content_overlay";

function ForumPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Forum</h2>}
      text_content={
        <ol style={{ lineHeight: "2",textAlign:"left"}}>
          <li>
            Sahyadri E-News, Issue 88, Aghanashini Estuary, a Ramsar Wetland of
            International Importance-
            <a href="https://wgbis.ces.iisc.ac.in/biodiversity/sahyadri_enews/newsletter/Issue88/index.html">
              https://wgbis.ces.iisc.ac.in/biodiversity/sahyadri_enews/newsletter/Issue88/index.html
            </a>
          </li>
          <li>
            Kerala Forest Department-{" "}
            <a href="https://forest.kerala.gov.in/en/flora-of-kerala/">
              https://forest.kerala.gov.in/en/flora-of-kerala/
            </a>
          </li>
          <li>
            Karshika Keralam-{" "}
            <a href="https://keralaagriculture.gov.in/en/home/">
              https://keralaagriculture.gov.in/en/home/
            </a>
          </li>
          <li>
            Kerala Forest Research Institute-{" "}
            <a href="https://keralaagriculture.gov.in/en/home/">
              https://keralaagriculture.gov.in/en/home/
            </a>
          </li>
          <li>
            Malabar Botanical Garden and Institute for Plant Sciences (MBGIPS)-{" "}
            <a href="https://mbgips.in/">https://mbgips.in/</a>
          </li>
          <li>
            Conservation of Agro, plant and fish diversity of Kerala- Kerala
            State Biodiversity Board (KSBB)-
            <a href="https://keralabiodiversity.org/">
              https://keralabiodiversity.org/
            </a>
          </li>
          <li>
            Biodiversity Management Committee-{" "}
            <a href="https://keralabiodiversity.org/">
              https://keralabiodiversity.org/
            </a>
          </li>
          <li>
            Forest First Samithi-{" "}
            <a href="https://www.thehabitatstrust.org/">
              https://www.thehabitatstrust.org/
            </a>
          </li>
          <li>
            Tanal-{" "}
            <a href="https://thanaltrust.org/">https://thanaltrust.org/</a>
          </li>
          <li>
            Ayurvedha Forum-{" "}
            <a href="https://www.ayurvedakendra.in/community/">
              https://www.ayurvedakendra.in/community/
            </a>
          </li>
          <li>
            Vembanad, Community Environmental Resource Centre, Ashoka Trust for
            Research in Ecology and the Environment (ATREE)-{" "}
            <a href="https://www.vembanad.org/">https://www.vembanad.org/</a>
          </li>
          <li>
            Flora of Kerala-{" "}
            <a href="https://forest.kerala.gov.in/">
              https://forest.kerala.gov.in/
            </a>
          </li>
          <li>
            Eflora Kerala-{" "}
            <a href="https://www.eflorakerala.com/">
              https://www.eflorakerala.com/
            </a>
          </li>
          <li>
            Medicinal Plants Forum-{" "}
            <a href="https://forum.ayurvedicmedicinalplants.com/">
              https://forum.ayurvedicmedicinalplants.com/
            </a>
          </li>
          <li>
            Digital Flora-{" "}
            <a href="https://stthomas.ac.in/">https://stthomas.ac.in/</a>
          </li>
          <li>
            Arya Vaidya Sala, Kottakkal-{" "}
            <a href="https://www.aryavaidyasala.com/">
              https://www.aryavaidyasala.com/
            </a>
          </li>
          <li>
            Indian Youth Climate Network (IYCN):{" "}
            <a href="https://iycn.in/">https://iycn.in/</a>
          </li>
          <li>
            Wild Life Trust of India-{" "}
            <a href="https://www.wti.org.in/">https://www.wti.org.in/</a>
          </li>
          <li>
            Green Yatra-{" "}
            <a href="https://www.greenyatra.org/index.php">
              https://www.greenyatra.org/index.php
            </a>
          </li>
          <li>
            The Indian Botanical Society-{" "}
            <a href="https://indianbotsoc.org/">https://indianbotsoc.org/</a>
          </li>
          <li>
            Botanical Survey of India-{" "}
            <a href="https://bsi.gov.in/">https://bsi.gov.in/</a>
          </li>
          <li>
            Protection of plant varieties and farmers rights authority-{" "}
            <a href="https://plantauthority.gov.in/plant-varieties-registry-related-information">
              https://plantauthority.gov.in/plant-varieties-registry-related-information
            </a>
          </li>
          <li>
            Hol&eacute;matthi Nature Foundation-{" "}
            <a href="https://www.holematthi.org/">
              https://www.holematthi.org/
            </a>
          </li>
          <li>
            Medicinal Plants and Trees-{" "}
            <a href="https://tree-nation.com/forum/topic/4130-medicinal-plants-and-trees">
              https://tree-nation.com/forum/topic/4130-medicinal-plants-and-trees
            </a>
          </li>
          <li>
            Pasumai Thaayagam - Green Motherland-{" "}
            <a href="https://www.globalhand.org/en">
              https://www.globalhand.org/en
            </a>
          </li>
          <li>
            Centre for Wildlife studies-{" "}
            <a href="https://cwsindia.org/">https://cwsindia.org/</a>
          </li>
          <li>
            Bombay Nature History Society-{" "}
            <a href="https://bnhs.org/home-page">https://bnhs.org/home-page</a>
          </li>
          <li>
            Forest and Environment Forum-{" "}
            <a href="https://forestry.proboards.com/">
              https://forestry.proboards.com/
            </a>
          </li>
          <li>
            Vanashakthi-{" "}
            <a href="https://vanashakti.org/">https://vanashakti.org/</a>
          </li>
          <li>Tarumitra (Friends of trees) - https://footprint.org.in/</li>
          <li>
            Wildlife Protection Society of India-{" "}
            <a href="https://www.wpsi-india.org/wpsi/index.php">
              https://www.wpsi-india.org/wpsi/index.php
            </a>
          </li>
          <li>
            International Environment forum-{" "}
            <a href="https://iefworld.org/">https://iefworld.org/</a>
          </li>
          <li>
            Environmental forum of India-{" "}
            <a href="https://evfindia.org/">https://evfindia.org/</a>
          </li>
          <li>
            Farmnest-{" "}
            <a href="https://discuss.farmnest.com/">
              https://discuss.farmnest.com/
            </a>
          </li>
          <li>
            Global forum on Agricultural research and innovation-{" "}
            <a href="https://gfair.network/">https://gfair.network/</a>
          </li>
          <li>
            UBC Botanical garden -{" "}
            <a href="https://www.botanicalgarden.ubc.ca/">
              https://www.botanicalgarden.ubc.ca/
            </a>
          </li>
          <li>
            IUCN (Internation Union for Conservation of Nature)-{" "}
            <a href="https://iucn.org/">https://iucn.org/</a>
          </li>
          <li>
            World Wildlife Fund-{" "}
            <a href="https://www.worldwildlife.org/">
              https://www.worldwildlife.org/
            </a>
          </li>
          <li>
            Food and Agriculture Organization of the United Nations-{" "}
            <a href="https://www.fao.org/home/en">
              https://www.fao.org/home/en
            </a>
          </li>
          <li>
            The Nature Conservancy-{" "}
            <a href="https://www.nature.org/content/tnc/nature/us/en-us.html">
              https://www.nature.org/content/tnc/nature/us/en-us.html
            </a>
          </li>
          <li>
            FORREST India-{" "}
            <a href="https://www.forrest-india.org/">
              https://www.forrest-india.org/
            </a>
          </li>
          <li>
            Nature Conservation Foundation-{" "}
            <a href="https://www.ncf-india.org/">https://www.ncf-india.org/</a>
          </li>
          <li>
            Centre for Plant Conservation-{" "}
            <a href="https://saveplants.org/">https://saveplants.org/</a>
          </li>
          <li>
            Fauna and Flora International-{" "}
            <a href="https://www.fauna-flora.org/">
              https://www.fauna-flora.org/
            </a>
          </li>
          <li>
            Wildlife Conservation Society-{" "}
            <a href="https://india.wcs.org/">https://india.wcs.org/</a>
          </li>
          <li>
            Conservation International-{" "}
            <a href="https://www.conservation.org/home">
              https://www.conservation.org/home
            </a>
          </li>
          <li>
            Ecological Society of America-{" "}
            <a href="https://esa.org/">https://esa.org/</a>
          </li>
          <li>
            Forest and Landscape Restoration Asia and the Pacific-{" "}
            <a href="https://www.fao.org/in-action/forest-landscape-restoration-asia/en">
              https://www.fao.org/in-action/forest-landscape-restoration-asia/en
            </a>
          </li>
          <li>
            Botanic Garden Networks in Asia-{" "}
            <a href="https://www.bgci.org/">https://www.bgci.org/</a>
          </li>
          <li>
            Plant Conservation Alliance-{" "}
            <a href="https://www.blm.gov/">https://www.blm.gov/</a>
          </li>
          <li>
            National Floriculture Forum History-{" "}
            <a href="https://endowment.org/national-floriculture-forum-history">
              https://endowment.org/national-floriculture-forum-history
            </a>
          </li>
        </ol>
      }
    />
  );
}

export default ForumPage;
